import { ReactNode } from 'react';
import { Paper } from '@ocx/ui';

type SweepstakesOfferDetailsContentProps = {
  children: ReactNode;
  p?: number; // SizingMultiplier values
};

export const SweepstakesOfferDetailsPaper = (props: SweepstakesOfferDetailsContentProps) => {
  const { children, p } = props;

  return (
    <Paper
      sx={(theme) => ({
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        p: p ? theme.spacing(p) : undefined,
        paddingBottom: p
          ? `calc(${theme.spacing(p)} + var(--ion-safe-area-bottom, 0px))`
          : 'var(--ion-safe-area-bottom, 0px)',
      })}>
      {children}
    </Paper>
  );
};
